export default __webpack_public_path__ + "static/media/bankIcon.527dc55e.svg";